var _defs, _path, _path2, _path3, _rect, _rect2, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path5, _rect11, _rect12, _path6, _path7, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calend\\xE1rio_1_vez_por_m\\xEAs",
    "data-name": "Calend\\xE1rio 1 vez por m\\xEAs",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123.19 121.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4{fill:none;}.cls-1,.cls-2,.cls-3,.cls-4{stroke:#343233;stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-5{stroke-width:3.31px;}.cls-2,.cls-6{fill:#d83f28;}.cls-2,.cls-4{stroke-width:2px;}.cls-3{stroke-width:0.56px;}.cls-5{fill:#343333;stroke:#343333;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.65,35.09H121.54a0,0,0,0,1,0,0v74.43a10.29,10.29,0,0,1-10.29,10.29H11.95A10.29,10.29,0,0,1,1.65,109.52V35.09a0,0,0,0,1,0,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.51,43.79H35.79a0,0,0,0,1,0,0V60.62a0,0,0,0,1,0,0H10.6a0,0,0,0,1,0,0V51.7A7.91,7.91,0,0,1,18.51,43.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.48,43.79H35.79a0,0,0,0,1,0,0V60.62a0,0,0,0,1,0,0H10.56a0,0,0,0,1,0,0V51.71A7.92,7.92,0,0,1,18.48,43.79Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 35.79,
    y: 43.79,
    width: 25.23,
    height: 16.83
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 61.01,
    y: 43.79,
    width: 25.23,
    height: 16.83
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.24,43.79h17.31a7.92,7.92,0,0,1,7.92,7.92v8.91a0,0,0,0,1,0,0H86.24a0,0,0,0,1,0,0V43.79A0,0,0,0,1,86.24,43.79Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 10.56,
    y: 60.62,
    width: 25.23,
    height: 16.83
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 35.79,
    y: 60.62,
    width: 25.23,
    height: 16.83
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 61.01,
    y: 60.62,
    width: 25.23,
    height: 16.83
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 86.24,
    y: 60.62,
    width: 25.23,
    height: 16.83
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 86.24,
    y: 77.45,
    width: 25.23,
    height: 16.83
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 10.6,
    y: 77.45,
    width: 25.19,
    height: 16.83
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 35.79,
    y: 77.45,
    width: 25.23,
    height: 16.83
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 61.01,
    y: 77.45,
    width: 25.23,
    height: 16.83
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.56,94.28H35.79a0,0,0,0,1,0,0v16.83a0,0,0,0,1,0,0H18.48a7.92,7.92,0,0,1-7.92-7.92V94.28A0,0,0,0,1,10.56,94.28Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 35.79,
    y: 94.28,
    width: 25.23,
    height: 16.83
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 61.01,
    y: 94.28,
    width: 25.23,
    height: 16.83
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.24,94.28h25.23a0,0,0,0,1,0,0v8.91a7.92,7.92,0,0,1-7.92,7.92H86.24a0,0,0,0,1,0,0V94.28A0,0,0,0,1,86.24,94.28Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.05,12h99.08a10.4,10.4,0,0,1,10.4,10.4V35.09a0,0,0,0,1,0,0H1.65a0,0,0,0,1,0,0V22.43A10.4,10.4,0,0,1,12.05,12Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 22.45,
    width: 9.91,
    height: 20.72,
    rx: 4.95
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 90.73,
    width: 9.91,
    height: 20.72,
    rx: 4.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthly);
export default __webpack_public_path__ + "static/media/monthly.ef899391e8d17657ede03a87e3bbd9b5.svg";
export { ForwardRef as ReactComponent };